module.exports = __webpack_public_path__ + "images/emoji/punch.5546128762e3d535da1f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/punch.png
// module id = /msP
// module chunks = 13